export default __webpack_public_path__ + "static/media/NIE_touchpoint_09.99123e7d.mp4";